export enum TerminologyLanguage {
  EN = 'EN',
  DE = 'DE',
  ES_LATAM = 'ES_LATAM'
}
